export default __webpack_public_path__ + "static/media/531.4aa0f7d9.gif";